import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

export class PageTitle extends Component {
    render() {
        const {title, className, style} = this.props;

        return (
            <section className={`text-center title-section pb-2 pb-sm-5 ${className}`} style={style}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-8">
                            <h2><Translate value={title} /></h2>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}